import "./ProjectImageSlider.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { MdArrowForwardIos } from "react-icons/md";
import { MdArrowBackIosNew } from "react-icons/md";
import { useRef, useState, useEffect } from "react";
import { baseUrl } from "../../../utils/apiData";
import { images } from "../../../utils/images";
import { GoArrowLeft } from "react-icons/go";
import { GoArrowRight } from "react-icons/go";

const ProjectImageSlider = ({ data }) => {
  const imgSliderRef = useRef();

  const [imageList, setImageList] = useState(data?.[0]?.slider_images);
  const [viewId, setViewId] = useState(data?.[0]?._id);

  const containerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  // Check scroll position to determine arrow visibility
  const checkScroll = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
    }
  };

  // Scroll container by a fixed amount
  const scrollBy = (pixels) => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: pixels,
        behavior: "smooth",
      });
    }
  };

  // Check scroll position on mount and when data changes
  useEffect(() => {
    checkScroll();
    // Add resize observer to handle window resizing
    const resizeObserver = new ResizeObserver(checkScroll);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }
    return () => resizeObserver.disconnect();
  }, [data]);

  return (
    <section className="project_image_slider p_b">
      <img
        src={images.densePattern}
        alt="Pattern"
        className="bg_pattern"
        style={{ opacity: "0.1" }}
      />
      <div className="content_wrap">
        <div className="tab_wrap" ref={containerRef} onScroll={checkScroll}>
          {data?.map((data) => {
            return (
              <button
                type="button"
                className={`square_btn ${viewId === data?._id ? "active" : ""}`}
                key={data?._id}
                onClick={() => {
                  setImageList(data?.slider_images);
                  setViewId(data?._id);
                }}
              >
                {data?.title}
              </button>
            );
          })}
        </div>
        {(showLeftArrow || showRightArrow) && (
          <div className="scroll_controle">
            {showLeftArrow ? (
              <button
                className="scroll-arrow left-arrow"
                onClick={() => scrollBy(-100)}
              >
                <GoArrowLeft />
              </button>
            ) : (
              <p></p>
            )}
            {showRightArrow ? (
              <button
                className="scroll-arrow right-arrow"
                onClick={() => scrollBy(100)}
              >
                <GoArrowRight />
              </button>
            ) : (
              <p></p>
            )}
          </div>
        )}
        {imageList?.length > 0 ? (
          <div className="project_img_slider">
            <button
              type="button"
              className="prev"
              onClick={() => imgSliderRef.current.swiper.slidePrev()}
            >
              <MdArrowBackIosNew />
            </button>

            <Swiper
              slidesPerView={1.5}
              centeredSlides={true}
              spaceBetween={16}
              grabCursor={true}
              pagination={{
                clickable: false,
              }}
              loop={true}
              modules={[]}
              className="mySwiper"
              ref={imgSliderRef}
              lazy={{ loadPrevNext: true }}
              speed={600}
              breakpoints={{
                480: {
                  slidesPerView: 1.5,
                  spaceBetween: 16,
                },
                10: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
              }}
            >
              {imageList?.map((img, l) => {
                return (
                  <SwiperSlide key={l}>
                    <img src={`${baseUrl}/${img}`} alt="Project" />
                  </SwiperSlide>
                );
              })}
            </Swiper>

            <button
              type="button"
              className="next"
              onClick={() => imgSliderRef.current.swiper.slideNext()}
            >
              <MdArrowForwardIos />
            </button>
            <div className="overlay_grid">
              <div className="side"></div>
              <div className="center"></div>
              <div className="side"></div>
            </div>
          </div>
        ) : (
          <p className="darkGold text-center">Data not found...</p>
        )}
      </div>
    </section>
  );
};

export default ProjectImageSlider;
